<div id="carouselControls" data-interval="false" class="carousel slide" data-ride="carousel">
    <div class="carousel-inner"> 
      <img class="btn-menu element-over-hand" (click)="showDropDown()" src="assets/multimedia-module/edit.png"> 
      <div>
        <div *ngIf="isMenuOpened" class="menu-content-box">
          <div class="element-over-hand" (click)="uploadImage()">
            <span>                
              <img class="menu-icon" src="assets/images/upload.png">
            </span>
            <span class="menu-item">{{"lbl_upload" | translate}}</span>
          </div> 
          <div class="element-over-hand" (click)="editImage()">
            <span>
              <img class="menu-icon" src="assets/images/edit.png">        
            </span>              
            <span class="menu-item">{{"lbl_edit" | translate}}</span>
          </div>
          <div [ngClass]="[isEnableForUnlnik ? 'element-over-hand':'']" (click)="unlinkImage()">
            <span>
              <img *ngIf="isEnableForUnlnik" class="menu-icon" src="assets/images/delete.png">
              <img *ngIf="!isEnableForUnlnik" class="menu-icon" src="assets/images/delete_disable.png">
            </span>
            <span [ngClass]="[isEnableForUnlnik ? 'menu-item':'menu-item-disable']">{{"lbl_unlink" | translate}}</span>
          </div>                      
          <div  [ngClass]="[isEnableSetPrimary ? 'element-over-hand':'']" (click)="setImageAsPrimary()">
            <span>
              <img *ngIf="isEnableSetPrimary" class="menu-icon" src="assets/images/select_primary.png">
              <img *ngIf="!isEnableSetPrimary" class="menu-icon" src="assets/images/select_primary_disable.png">
            </span>
            <span [ngClass]="[isEnableSetPrimary ? 'menu-item':'menu-item-disable']">{{"lbl_setasprimary" | translate}}</span>
          </div>
        </div>
      </div>
      <div class="carousel-item" *ngFor = "let item of carouselImages let i = index" [ngClass]="{'active': i == 0 }">       
        <img class="prof-image" [src]="getCarouselImageUrl(item)"/>        
      </div>
    </div>
    <a *ngIf="carouselImages.length > 1 && currentMediaIndex > 0 " class="carousel-control-prev" href="#carouselControls" role="button" data-slide="prev" (click)="getPreviousItem()">
        <span aria-hidden="true">
          <i class="fa-solid fa-circle-chevron-left carousel-control"></i>
        </span>
      <!-- <span class="sr-only">Previous</span> -->
    </a>
    <a *ngIf="carouselImages.length > 1 && currentMediaIndex < carouselImages.length - 1" class="carousel-control-next" href="#carouselControls" role="button" data-slide="next" (click)="getNextItem()">
        <span aria-hidden="true">
          <i class="fa-solid fa-circle-chevron-right carousel-control"></i>
        </span>
      <!-- <span class="sr-only">Next</span> -->
    </a>
</div>
